import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './cancel.css';
import TicketItems from './TicketItems';

const LOGO = 'https://portal.parkquility.com/public/pq_logo.png';

export default class App extends Component {

  constructor(props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isCancellable = this.isCancellable.bind(this);
    this.cancelledText = this.cancelledText.bind(this);
    this.manageSelectedTickets = this.manageSelectedTickets.bind(this);
    this.baseUrl = process.env.REACT_APP_API_URL;
    const urlParams = new URLSearchParams(window.location.search);
    this.passType = urlParams.get('type');
    this.state = {
      passHash: urlParams.get('id'),
      loading: false,
      submitting: false,
      cancelledNow: false,
      ticketData: []
    };
  }

  componentDidMount(){
    this.refreshAfterSleep();
    this.getTickets();
  }

  refreshAfterSleep(){
    const SAMPLE_RATE = 5000;
    let lastSample = Date.now();
    function refresh() {
      if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
        window.location.reload();
      }
      lastSample = Date.now();
      setTimeout(refresh, SAMPLE_RATE);
    }
    refresh();
  }

  isCancellable(item){
    const status = (item.subscription_status || 'active').toLowerCase();
    return status === 'active';
  }

  cancelledText(item){
    return item.cancelled_now ? 'Subscription cancelled' : 'Already cancelled';
  }

  manageSelectedTickets(id){
    const ticketData = this.state.ticketData.map(item => item.id === id ? {...item, selected: !item.selected} : item);
    this.setState({ ticketData });
  }

  getTickets(){
    if(!this.state.passHash) return;
    this.setState({loading: true});
    fetch(`${this.baseUrl}/parking/monthly/detail/hash?pass_hash=${this.state.passHash}`)
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          const respData = Array.isArray(resp.data) ? resp.data : Object.keys(resp.data).length === 0 ? [] : [resp.data];
          const ticketData = respData.map(item => ({...item, selected: true}));
          this.setState({loading: false, ticketData}, () => {
            if(!ticketData.length) toast.error('No passes found');
          });
        }else{
          const errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
          this.setState({loading: false});
          toast.error(errMsg);
        }
      })
      .catch(() => {
        this.setState({loading: false});
        toast.error('Something went wrong');
      });
  }

  handleSubmit(e){
    e.preventDefault();
    const selectedPasses = this.state.ticketData.filter(x => x.selected && (x.pass_id || x.id) && this.isCancellable(x));
    const passList = selectedPasses.map(item => ({
      pass_id: String(item.pass_id || item.id),
      payment_type: item.payment_type || this.passType || 'individual'
    }));
    if(!passList.length){
      toast.error('No pass selected');
      return;
    }
    this.setState({submitting: true, loading: true});
    fetch(`${this.baseUrl}/parking/monthly/subscription/cancel`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ pass_list: passList })
    })
      .then(response => response.json())
      .then(resp => {
        if(resp.status === "SUCCESS"){
          const ids = selectedPasses.map(x => x.id);
          const ticketData = this.state.ticketData.map(item => ids.includes(item.id)
            ? {...item, subscription_status: 'cancelled', cancelled_now: true}
            : item);
          window.scrollTo(0, 0);
          this.setState({ticketData, cancelledNow: true, submitting: false, loading: false});
        }else{
          const errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
          this.setState({submitting: false, loading: false});
          toast.error(errMsg, { autoClose: errMsg.length > 20 ? 10000 : 2000 });
        }
      })
      .catch(() => {
        this.setState({submitting: false, loading: false});
        toast.error('Something went wrong');
      });
  }

  render() {
    const { ticketData, loading, submitting, cancelledNow } = this.state;
    const hasRows = ticketData.length > 0;
    const canCancel = ticketData.some(item => this.isCancellable(item));
    const showCancelled = hasRows && !canCancel;

    return (
      <div className="page">
        {loading && <div className="loader-veil"><div className="loader-ring" /></div>}
        <img className="page-logo" src={LOGO} alt="Parkquility" />
        <h1 className="page-title">{showCancelled ? 'Subscription Cancelled' : 'Cancel Monthly Subscription'}</h1>
        <p className="page-subtitle">
          {showCancelled
            ? (cancelledNow
                ? 'This monthly subscription has been cancelled and will not renew.'
                : 'This monthly subscription is no longer active and will not renew.')
            : 'Review the subscription details below before confirming the cancellation.'}
        </p>

        <form onSubmit={this.handleSubmit}>
          {ticketData.map((item, index) => (
            <TicketItems
              key={'t' + index}
              data={item}
              length={ticketData.length}
              isCancellable={this.isCancellable}
              cancelledText={this.cancelledText}
              manageSelectedTickets={this.manageSelectedTickets}
            />
          ))}
          {canCancel && (
            <div>
              <button className="confirm-btn" id="pay-submit" type="submit" disabled={submitting}>Confirm Cancellation</button>
              <p className="confirm-note">This action cannot be undone.</p>
            </div>
          )}
        </form>
        <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
      </div>
    );
  }
}
